// Frozen-zone arithmetic — where "prep runs a day ahead" lands on the canvas.
// All values are minutes from today 00:00 (the Gantt's absMin space), so they
// can be negative before 06:00 (the current production day started yesterday).
// See the FROZEN ZONE block in ganttConfig.ts for the operating rhythm.
import { SHIFT_START_MIN, PREP_LEAD_MIN } from './ganttConfig';

export interface FrozenZones {
  /** Start of the current production day — the most recent 06:00. */
  lockedStart: number;
  /** Start of the day whose prep kicked off this morning (locked + 24h). */
  prepStart: number;
  /** The freeze horizon — everything at/after this is still open. */
  freezeAbs: number;
  /** When the horizon next rolls forward a day: tomorrow 06:00. */
  nextFreezeAt: number;
}

export function frozenZones(nowAbs: number): FrozenZones {
  const lockedStart = Math.floor((nowAbs - SHIFT_START_MIN) / 1440) * 1440 + SHIFT_START_MIN;
  const prepStart = lockedStart + PREP_LEAD_MIN;
  return {
    lockedStart,
    prepStart,
    freezeAbs: prepStart + 1440,
    nextFreezeAt: lockedStart + 1440,
  };
}
